export default {
  baseUrl: 'http://robohotel.volhinsoft.ru',
  accessToken: localStorage.getItem("RobohotelTableDataAccessToken") || null,
  timezone: localStorage.getItem("RobohotelTZ") || null,
  requestCancellers: {},
  scrolled: 0,
  storeActiveGroup: localStorage.getItem("RobohotelActiveGroup") || null,
};
